module.exports = __webpack_public_path__ + "images/logo_cicil_logo_w.svg";